import CryptoJS from 'crypto-js';

import api from '@/api/index';
import { CRYPTO_KEY } from '@/fixtures/Hash';

const namespaced = true;

const state = {
  companies: [],
  dropdownCompanies: [],
  thirdParties: [],
  selectedCompanyId: null,
  sites: [],
  companiesFiles: {}
};

const getters = {
  companies: (state) => state.companies,
  dropdownCompanies: (state) => state.dropdownCompanies,
  thirdParties: (state) => state.thirdParties,
  selectedCompanyId: (state) =>
    state.selectedCompanyId
      ? Number(CryptoJS.AES.decrypt(state.selectedCompanyId, CRYPTO_KEY).toString(CryptoJS.enc.Utf8))
      : null,
  sites: (state) => state.sites,
  companiesFiles: (state) => state.companiesFiles
};

const mutations = {
  SET_COMPANIES: (state, payload) => {
    state.companies = payload;
  },
  SET_DROPDOWN_COMPANIES: (state, payload) => {
    state.dropdownCompanies = payload;
  },
  SET_THIRD_PARTIES: (state, payload) => {
    state.thirdParties = payload;
  },
  SET_SELECTED_COMPANY_ID: (state, payload) => {
    state.selectedCompanyId = CryptoJS.AES.encrypt(payload.toString(), CRYPTO_KEY).toString();
  },
  SET_SITES: (state, payload) => {
    state.sites = payload;
  },
  SET_COMPANIES_FILES: (state, payload) => {
    state.companiesFiles = payload;
  }
};

const actions = {
  async fetchCompanies({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getCompanies(filter);

      if (data.error) {
        commit('SET_COMPANIES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      if(filter.limit && filter.page) {
        commit('SET_COMPANIES', data.data)
        commit('Table/SET_TOTAL_DATA', data.total, { root: true })
        commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      } else {
        commit('SET_COMPANIES', data)
      }
      return data
    } catch (error) {
      throw error;
    }
  },

  async fetchSites({ commit }, payload) {
    try {
      const { data } = await api.getSites(payload);
      if (data.error) {
        commit('SET_SITES', []);
        return;
      }
      commit('SET_SITES', data);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async fetchDropdownCompanies({ commit }, payload) {
    try {
      const filters = {
        is_master_data: true,
        type: 'TUG_OWNER',
        sort_dir: 'asc',
        sort_by: 'name',
        ...payload
      };

      const { data } = await api.getCompanies(filters);

      if (data?.error) {
        commit('SET_DROPDOWN_COMPANIES', []);
        return;
      }

      const list = Array.isArray(data?.data) ? data.data : data;
      const mapped = Array.isArray(list)
        ? list.map((item) => ({ id: item.id, name: item.name }))
        : [];

      commit('SET_DROPDOWN_COMPANIES', mapped);
      return mapped;
    } catch (error) {
      throw error;
    }
  },

  async fetchThirdParties({ commit }, payload) {
    try {
      const { data } = await api.getAllThirdParties(payload);
      commit('SET_THIRD_PARTIES', data);
    } catch (error) {
      throw error;
    }
  },

  async postCompany({}, payload) {
    try {
      await api.postCompany(payload);
    } catch (error) {
      throw error.data
    }
  },

  async getCompanyDetails({}, payload) {
    try {
      const data = await api.getCompaniesDetails(payload);
      return data;
    } catch (error) {
      throw error.data
    }
  },

  async putCompany({}, payload) {
    try {
      await api.putCompany(payload.id, payload.form);
    } catch (error) {
      throw error.data
    }
  },

  async deleteCompany({}, payload) {
    try {
      await api.deleteCompany(payload);
    } catch (error) {
      throw error;
    }
  },
  async downloadCompanies({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getCompaniesExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_COMPANIES_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetCompaniesFiles({ commit }) {
    commit('SET_COMPANIES_FILES', {})
  },

  async fetchAllCompanies({ commit }, payload) {
    try {
      const data = await api.getCompanies(payload)
      if (data.error) {
        commit('SET_COMPANIES', [])
        return
      }

      commit('SET_COMPANIES', data.data)
      return data
    } catch (error) {
      throw error;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
